module.exports = __webpack_public_path__ + "static/media/att_30.d7554a33.jpg";